import React from 'react';
import { Control, Controller, useFormState } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';

import { ThemeManager } from '../../themes/theme-manager';
import { CheckBox } from '../check-box/check-box';
import { Hyperlink } from '../hyperlink/hyperlink';

type Form = {
  tosChecked: boolean;
};

type Props<T extends Form> = {
  formControl: Control<T, any>;
  disabled: boolean;
};

const TermsOfServiceCheckBox = <T extends Form>(props: Props<T>) => {
  const { t } = useTranslation();
  const { errors } = useFormState({ control: props.formControl });

  return (
    <Controller
      control={props.formControl}
      // @ts-ignore
      defaultValue={false}
      // @ts-ignore
      name="tosChecked"
      render={({ field }) => (
        <CheckBox
          {...field}
          alignSelf="flex-start"
          // Important to set disabled on checkbox and not on the controller.
          // Otherwise form value for 'tosChecked' will be undefined when request fails after
          // submitting.
          // Test with an invalid request body to simulate a failure and then click the
          // verify button again. Then the validation message appears for checkbox even
          // though it's checked.
          disabled={props.disabled}
          errorMessage={errors.tosChecked?.message?.toString()}
        >
          <Trans
            components={{
              hyperlink: (
                <Hyperlink target="_blank" url={ThemeManager.instance.getTermsOfServiceUrl()} />
              ),
            }}
            i18nKey="termsOfServiceCheckBox.text"
            ns="components"
          />
        </CheckBox>
      )}
      rules={{
        required: {
          value: true,
          message: t('termsOfServiceCheckBox.validationError', {
            ns: 'components',
          }),
        },
      }}
    />
  );
};

export { TermsOfServiceCheckBox };
